document.addEventListener('DOMContentLoaded', function () {
  
  document.querySelectorAll('.js-item-properties-title').forEach(property => {
      property.addEventListener('click', function (e) {
      e.preventDefault();
      const parent = e.target.closest('.item-properties');
      if (parent) parent.classList.toggle('active');
    });
  });
  
});